// extracted by mini-css-extract-plugin
export var academyMargin = "accordion-module--academyMargin--d1ac3";
export var accordion = "accordion-module--accordion--c7023";
export var eyebrow = "accordion-module--eyebrow--a6f7a";
export var fullWidth = "accordion-module--fullWidth--2ef48";
export var grid = "accordion-module--grid--c055b";
export var gridMedia = "accordion-module--gridMedia--15d8b";
export var gridText = "accordion-module--gridText--7bda0";
export var headline = "accordion-module--headline--b1f5b";
export var mediaAlignLeft = "accordion-module--mediaAlignLeft--d8a2d";
export var mediaAlignRight = "accordion-module--mediaAlignRight--675f2";
export var mediaOverride = "accordion-module--mediaOverride--51362";